module.exports = __webpack_public_path__ + "resources/img/img_tibero5_m_en.f73e3746c6c51673db5be5ea67971a15.png";